export const cilMediaRecord = ["24 24","<path d='M12 3.375c-4.756 0-8.625 3.869-8.625 8.625s3.869 8.625 8.625 8.625 8.625-3.869 8.625-8.625-3.869-8.625-8.625-8.625zM12 19.125c-3.929 0-7.125-3.196-7.125-7.125s3.196-7.125 7.125-7.125 7.125 3.196 7.125 7.125-3.196 7.125-7.125 7.125z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-media-record.js
// module id = null
// module chunks = 